var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBetaHighlightedLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 12,
    viewBox: "0 0 28 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 12,
    fill: "#FF8736"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.1 3.4H8.364L9.124 4.16V5.712L8.764 6.08L9.372 6.696V8.192L8.564 9H5.1V3.4ZM8.012 5.864L8.372 5.504V4.408L8.012 4.056H5.852V5.864H8.012ZM8.196 8.344L8.62 7.928V6.92L8.196 6.496H5.852V8.344H8.196ZM10.3344 3.4H14.0944V4.072H11.1024V5.856H13.8624V6.52H11.1024V8.328H14.0944V9H10.3344V3.4ZM16.3411 4.064H14.6531V3.4H18.7971V4.064H17.1091V9H16.3411V4.064ZM20.4093 3.4H21.1773L23.1933 9H22.4013L21.9053 7.576H19.6893L19.1933 9H18.4013L20.4093 3.4ZM21.7053 6.928L20.8013 4.312H20.7853L19.8973 6.928H21.7053Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetaHighlightedLarge);
export default __webpack_public_path__ + "static/media/beta_highlighted_large.7371489995ece294da19ca03dcc92fb1.svg";
export { ForwardRef as ReactComponent };